import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API } from 'src/app/configs/api.config';
import { PostSimple } from '../model/wordpress.model';
import { AuthService } from './auth.service';
import { ProfileService } from 'src/app/pages/profile/profile.service';

@Injectable()
export class BindService {

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private profileService: ProfileService
    ) { }

    getPostList() {
        return this.http.get<PostSimple[]>(API.WORDPRESS.POST_LIST)
    }

    bind() {
        let url = "https://github.com/login/oauth/authorize?client_id=cb48aa7985175bd7ad0d&scope=public_repo&state=" + this.authService.userInfo.userId;
        window.open(url);
        let n = 0;
        let timer = setInterval(() => {
            this.authService.getUserInfo();
            n++;
            if (n > 5 || this.authService.userInfo.bindGithub) {
                clearInterval(timer)
                this.profileService.getUserProfile();
            }
        }, 5000);
    }

    unbind(name = 'github') {
        let url = API.USER_BOUND_LIST + "?name=" + name;
        return this.http.delete<ResponseModel>(url).toPromise()
    }


}
